import React, { Component } from 'react'
import '../../../styles/checkout/mainStyle.css'
import { connect } from 'react-redux'
import { selectMode } from '../../../actions/commonActions'

const isIE = /*@cc_on!@*/false || !!document.documentMode;

export class ClientSideCheckout extends Component {
    state = {
        topRef: React.createRef()
    }

    componentDidMount() {
        this.props.selectMode('integration_guide');
    }
    
    onScrollToTop() {
        this.state.topRef.current.scrollIntoView()
        window.document.body.scrollIntoView(true)
    }

    render() {
        return (
            <div  className= "stepPageContainer">
                <h3 ref={this.state.topRef} className="stepPageTitle">Client-Side Checkout Page</h3> 
                <p style={{marginTop: '3vh'}}>In order to prepare your client-side checkout page for interacting with Moneris Checkout, you need to do a few tasks first:</p>
                <ol style={{paddingInlineStart: "20px", paddingLeft: isIE ? '2vw' : ''}}>
                    <li>Add a call to the Moneris Checkout JavaScript library in a &lt;script&gt; tag:<br></br>
                        Test<br></br>
                        <pre>
                            <span id="code1">&lt;script src="https://gatewayt.moneris.com/chktv2/js/chkt_v2.00.js"&gt;</span>
                        </pre>
                                Production<br></br>
                        <pre>
                            <span id="code2">&lt;script src="https://gateway.moneris.com/chktv2/js/chkt_v2.00.js"&gt;</span>
                        </pre>
                    </li>
                    <li>Create a &lt;div&gt; in the HTML:<br></br>
                        <pre>
                            <span id="code3">&lt;div id="monerisCheckout"&gt;&lt;/div&gt;</span>
                        </pre>
                        (Optional): If you are not using the "Full screen" window sizing option, you will need to define the size of your window by creating another &lt;div&gt; around this one, for example:<br></br>
                        <pre>
                                <span id="code3">
                                    &lt;div id="outerDiv" style="width:400px"; height"300px"&gt;&emsp;&lt;div id="monerisCheckout"&gt;&lt;/div&gt;&lt;/div&gt;
                                </span>
                        </pre>
                    </li>
                    <li>Instantiate the monerisCheckout object and set it up:<br></br>
                        <pre>
                            <span id="code4">
                                var myCheckout = new monerisCheckout();<br/>
                                myCheckout.setMode("qa");<br/>
                                myCheckout.setCheckoutDiv("monerisCheckout");</span>
                        </pre>
                    </li>
                    <li>Set callbacks in JavaScript:<br></br>
                        <pre>
                            <span id="code5">
                                var myCheckout = new monerisCheckout();<br/>
                                myCheckout.setCallback("page_loaded", myPageLoad);<br/>
                                myCheckout.setCallback("cancel_transaction", myCancelTransaction);<br/>
                                myCheckout.setCallback("error_event", myErrorEvent);<br/>
                                myCheckout.setCallback("payment_receipt", myPaymentReceipt);<br/>
                                myCheckout.setCallback("payment_complete", myPaymentComplete);
                            </span>
                        </pre>
                    </li>
                </ol>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    return { mode};
}

export default connect(mapStateToProps, { selectMode})(ClientSideCheckout)

